<template>
    <div>
        <div class="flex justify-between text-xs text-secondary-500 mb-2">
            <span>${{ min }}</span>
            <span>${{ max }}</span>
        </div>

        <SliderRoot v-model="sliderValue" :min="min" :max="max">
            <SliderTrack>
                <SliderRange />
            </SliderTrack>

            <SliderThumb />
        </SliderRoot>
    </div>
</template>

<script>
import {
    SliderRange, SliderRoot, SliderThumb, SliderTrack,
} from 'reka-ui';
import debounce from '../utils/debounce';

export default {
    components: {
        SliderRoot,
        SliderRange,
        SliderThumb,
        SliderTrack,
    },

    props: {
        min: {
            type: Number,
            required: true,
        },
        max: {
            type: Number,
            required: true,
        },
    },

    computed: {
        sliderValue: {
            get() {
                return this.localValue;
            },
            set: debounce(function(value) {
                this.localValue = value;
            }, 500),
        },
    },
};
</script>
